import { render, staticRenderFns } from "./NewOrder.vue?vue&type=template&id=73354cc6&scoped=true&"
import script from "./NewOrder.vue?vue&type=script&lang=js&"
export * from "./NewOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73354cc6",
  null
  
)

export default component.exports